module.exports = __webpack_public_path__ + "static/img/bg-role.7f512cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer2/bg-role.png
// module id = x8S3
// module chunks = 1